import { useRecoilValue } from 'recoil';
import { selectedLinkIdState } from '../../storage/links';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { LinkDetail } from '../links/LinkDetail';
import { LinkList } from '../links/LinkList';
import { LinksProvider } from '../providers/LinksProvider';

export function LinksPage() {
  const selectedLinkId = useRecoilValue(selectedLinkIdState);

  return (
    <>
      <LinksProvider />
      <FloatingCardsLayout
        contentSize="medium"
        list={<LinkList />}
        content={selectedLinkId !== undefined && <LinkDetail />}
      />
    </>
  );
}
